/*
* 组织架构组件
* zxw
* 创建时间：
* 修改时间：2026-08-13
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Button,
    InputNumber,
    Space,
    Tag,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import Entity from './OrgStructureEntity.js';

const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.title, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [update, refresh]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '架构层级', key: 'level',
            sorter: (a, b) => a.level - b.level,
            render: (record) => <Tag color={CNF.swatches[CNF.currentSwatche][0]}>{record.level}</Tag>
        },
        {
            title: '层级序号', key: 'sn',
            sorter: (a, b) => a.sn - b.sn,
            render: (record) => <Tag color={CNF.swatches[CNF.currentSwatche][1]}>{record.sn}</Tag>
        },
        { title: '架构标题', dataIndex: 'title', key: 'title', },
        {
            title: '负责人员', key: 'name',
            render: (record) => record.name ? record.name : '-'
        },
        {
            title: '组织职能类型', key: 'org_function_type',
            render: (record) => CNF.orgFunctionTypes.find(item => parseInt(record.org_function_type) === parseInt(item.value))?.key,
        },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', fixed: 'right', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', fixed: 'right', width: CNF.tableCreateTimeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, fixed: 'right', hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                showSorterTooltip={{ target: 'sorter-icon' }}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
        </>
    );
}

const OrgStructure = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [orgInfosLists, setOrgInfosLists] = useState([]);
    const [orgInfoULID, setOrgInfoULID] = useState('');
    const [level, setLevel] = useState(0);
    const [title, setTitle] = useState('');
    const [orgFunctionType, setOrgFunctionType] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleOrgInfoULIDChange = useCallback((value) => {
        setOrgInfoULID(value);
        setCurrentIndex(1);
    }, []);

    const handleLevelChange = useCallback((value) => {
        setLevel(value);
        setCurrentIndex(1);
    }, []);

    const handleTitleChange = useCallback((e) => {
        setTitle(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleOrgFunctionTypeChange = useCallback((value) => {
        setOrgFunctionType(value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        /***
         * 获取组织下拉列表
         */
        const orgInfoDDList = () => {
            const params = {
                rss: 'list',
                page_size: CNF.maxPageSize,
                current_index: 1
            };
            $.ajax({
                url: `${CNF.api}orgs/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET',
            }).done((data) => {
                if (data.res === 0) {
                    setOrgInfosLists(data.dat || []);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
        }
        orgInfoDDList();
    }, [messageApi]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            org_info_ulid: orgInfoULID,
            level,
            title,
            org_function_type: orgFunctionType,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, orgInfoULID, level, title, orgFunctionType]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                {orgInfosLists && orgInfosLists.length > 1 &&
                    <Select
                        value={orgInfoULID}
                        style={{ width: '100%' }}
                        onChange={handleOrgInfoULIDChange}
                        placeholder="请选择组织"
                        allowClear={orgInfosLists.length > 1}
                        options={[
                            ...(orgInfosLists.length > 1 ? [{ value: '', label: '请选择组织' }] : []),
                            ...orgInfosLists.map(item => ({
                                value: item.key,
                                label: item.name,
                                key: item.key,
                            }))
                        ]}
                    />
                }<InputNumber
                    onChange={handleLevelChange}
                    placeholder='架构层级'
                    min={0}
                    max={9}
                />
                <Input
                    onChange={handleTitleChange}
                    placeholder='架构标题'
                    value={title}
                />
                <Select
                    allowClear
                    placeholder='组织职能类型'
                    style={{ width: '100%' }}
                    value={orgFunctionType || undefined}
                    onChange={handleOrgFunctionTypeChange}
                    options={CNF.orgFunctionTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status || undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
                orgInfosLists={orgInfosLists}
            />
        </>
    );
}

export default OrgStructure